import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExifService } from './exif.service';
import { ImageCropperComponent } from './image-cropper.component';
import { ImageCropperExifService } from './image-cropper-exif.service';
export class ImageCropperModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        CommonModule
    ],
    declarations: [
        ImageCropperComponent
    ],
    exports: [
        ImageCropperComponent
    ],
    /**
     * Expose Services and Providers into Angular's dependency injection.
     */
    providers: [
        ExifService,
        ImageCropperExifService
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ImageCropperModule_tsickle_Closure_declarations() {
/** @type {?} */
ImageCropperModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ImageCropperModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
